import {
    httpGetSpecialists,
    HttpGetSpecialistsOptions,
    HttpGetSpelicialistsResponse
} from '@/features/projects/specialists/http/specialists.http'
import {QUERY_KEYS} from '@/queryClient'
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'

export const useGetInfiniteSpecialists = ({
    params,
    options
}: {
    params: HttpGetSpecialistsOptions['params']
    options?: Pick<UseInfiniteQueryOptions<HttpGetSpelicialistsResponse>, 'enabled'>
}) => {
    return useInfiniteQuery({
        queryKey: [QUERY_KEYS.SPECIALISTS, params],
        queryFn: ({pageParam = 1}) => httpGetSpecialists({params: {...params, page: pageParam}}),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })
}
